// extracted by mini-css-extract-plugin
export default {"content":"EnergyAlarmRule_content__+DtNm","wrapperPadding":"EnergyAlarmRule_wrapperPadding__u71s4"};